export default __webpack_public_path__ + "images/logoThisWorks.123b67bbff23e660003d649f87ee15ac.svg"